import React from "react";
import ReactSelect, { type GroupBase } from "react-select";
import { type CommonReactSelectWrapperProps } from "../models";
import { ReactSelectDropdownVariant, useReactSelectDropdown } from "../hooks";
import { useValidateIsNotNull } from "formvalidation/hooks";
import { ScrollableItems } from "formvalidation/FormContext";

interface ReactSelectWrapperProps<TOption, IsMulti extends boolean = false, TId = number> extends CommonReactSelectWrapperProps<TOption, IsMulti, TId> {
  options: TOption[] | Array<GroupBase<TOption>>
  variant?: ReactSelectDropdownVariant
}

const BaseReactSelectDropdown = <TOption extends object, IsMulti extends boolean = false, TId = number>(props: ReactSelectWrapperProps<TOption, IsMulti, TId>) => {
  let validationRef: React.RefObject<ScrollableItems>;
  let hasErrorFromValidator: boolean = undefined;
  if (props.config?.validatorKey) {
    const validation = useValidateIsNotNull({
      key: props.config.validatorKey,
      title: props.config.validatorKey,
      value: props.value,
    });
    validationRef = validation.ref;
    hasErrorFromValidator = validation.error.hasError;
  }

  const reactSelect = useReactSelectDropdown(props, props.variant, hasErrorFromValidator);

  let options = props.options;
  if (props.excludeKeys != null) {
    if (options[0] != null && "options" in options[0] && "label" in options[0]) {
      throw new Error("Cannot use exclude keys with grouped options");
    }
    const set = new Set(props.excludeKeys);
    options = (props.options as TOption[]).filter(o => !set.has(props.getValue(o)));
  }

  return <div className="flex">
    <div ref={validationRef} className="grow1">
      <ReactSelect
        {...reactSelect.reactSelectProps}
        ref={reactSelect.ref}
        options={options}
      />
    </div>
  </div>;
};

export default BaseReactSelectDropdown;